(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-list"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const carousels = document.querySelectorAll('.ccl-carousel');
  carousels.forEach(carousel => {
    if (typeof jQuery !== 'undefined' && jQuery(carousel).slick) {
      jQuery(carousel).slick({
        slidesToShow: parseInt(getComputedStyle(carousel).getPropertyValue('--desktop')),
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: false
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
